import { useEffect } from 'react';
import { DuplexerEventPayload, IndividualsDuplexerChannel } from '@wix/ai-scheduling-assistant-common-lib/commonTypes';
import { DomainEventSlug } from '@wix/ai-scheduling-assistant-common-lib/entities';
import { SCHEDULING_ASSISTANT_USER_APP_DEF_ID } from '@wix/ai-scheduling-assistant-constants';
import { Duplexer } from '@wix/duplexer-js';

export interface AssistantChatEntity {
  role: 'assistant' | 'thinking';
  content: string;
  done?: boolean;
  taskCreated?: { id: string; title: string };
}

class InstanceUpdater {
  private instance: string = '';

  setInstance(instance: string) {
    this.instance = instance;
  }

  getInstance() {
    return this.instance;
  }
}

const instanceUpdater = new InstanceUpdater();
const duplexer = new Duplexer('duplexer.wix.com', { instanceUpdater });
const appConnection = duplexer.connect({ appDefId: SCHEDULING_ASSISTANT_USER_APP_DEF_ID });

export function usePocDuplexer(handler: (payload: DuplexerEventPayload<AssistantChatEntity>) => void, signedInstance: string) {
  useEffect(() => {
    if (!signedInstance) {
      return;
    }

    instanceUpdater.setInstance(signedInstance);
    duplexer.triggerInstanceChanged();

    const subscription = appConnection.subscribe(IndividualsDuplexerChannel.ASSISTANT_CHAT);

    subscription.on(DomainEventSlug.UPDATED, handler);
    subscription.on(DomainEventSlug.ACTION, handler);

    return () => {
      subscription.off(DomainEventSlug.UPDATED, handler);
      subscription.off(DomainEventSlug.ACTION, handler);
    };
  }, [handler, signedInstance]);
}
